import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getMrtApiBasepath} from '../ssr/helpers'
import fetch from 'cross-fetch'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const useCustomGetCategory = ({parameters}, requestOptions) => {
    const {getTokenWhenReady} = useAccessToken()
    const {site, locale} = useMultiSite()
    const origin = useAppOrigin()

    async function getCategories(parameters) {
        const token = await getTokenWhenReady()
        parameters.locale = locale.id
        parameters.alias = locale.alias
        parameters.site = site.id

        const headers = {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }

        const endpoint = origin + getMrtApiBasepath('/get-category-details')
        const response = await fetch(`${endpoint}?${new URLSearchParams(parameters)}`, {
            headers,
        })
        const data = await response.json()

        return data
    }

    return useQuery(
        ['getCategoryCustom', parameters.urlSegment, locale.id],
        () => getCategories(parameters),
        requestOptions,
    )
}

export default useCustomGetCategory
